import Deferred from 'promise-deferred'
import { getWeb3Async } from '@/servicies/blockchain/web3'
import { hasTransactionEvent } from '@/utils/transaction'
import { WEB3_PROVIDER_METAMASK, WEB3_PROVIDER_WALLETCONNECT } from '@/constants/blockchain'
import EventEmitter from 'events'

export async function signAndSend ({
  wallet,
  from,
  to,
  encodedAbi,
  blockchain
}) {
  const eventEmitter = new EventEmitter()
  const web3 = await getWeb3Async({ wallet, newInitWallet: true, walletBlockchain: blockchain })
  let responseEmitter = null
  if (wallet === WEB3_PROVIDER_METAMASK) {
    responseEmitter = web3.eth.sendTransaction({
      from,
      to,
      value: '0',
      data: encodedAbi,
    })
  }
  if (wallet === WEB3_PROVIDER_WALLETCONNECT) {
    responseEmitter = web3.eth.sendTransaction({
      from,
      to,
      value: '0',
      data: encodedAbi,
      chainId: web3.utils.toHex(blockchain)
    })
  }
  responseEmitter.on('transactionHash', (hash) => {
    setImmediate(() => eventEmitter.emit('transactionHash', hash))
  })
  responseEmitter.on('error', (error) => {
    setImmediate(() => eventEmitter.emit('error', error))
  })
  return eventEmitter
}

export async function awaitTransactionStatusAppliedBlockchain ({ blockchain, tx, eventSignature = null, eventAddress = null }) {
  const deferred = new Deferred()
  const interv = setInterval(async () => {
    const web3 = await getWeb3Async({ blockchain })
    const receipt = await web3.eth.getTransactionReceipt(tx)
    if (receipt?.status === false) {
      deferred.reject('receipt.status === false')
      clearInterval(interv)
    }
    if (receipt && receipt.blockNumber) {
      const blockNumber = await web3.eth.getBlockNumber()
      if (blockNumber - receipt.blockNumber >= 1) {
        if (eventSignature !== null) {
          if (hasTransactionEvent({
            receipt,
            signature: eventSignature,
            eventAddress,
          })) {
            deferred.resolve()
            clearInterval(interv)
          } else {
            deferred.reject('Not has transaction event')
            clearInterval(interv)
          }
        } else {
          deferred.resolve()
          clearInterval(interv)
        }
      }
    }
  }, 1000)
  return deferred.promise
}
